<template>
  <el-table-column
    :label="label"
    :prop="prop"
    class-name="route-code"
    :sortable="sortable"
  >
    <template slot-scope="scope">
      <el-tag v-if='scope.row.route_code'>
        {{scope.row.route_code}}
      </el-tag>
      <el-tag v-else>
        -
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '線別'
    },
    prop: {
      type: String,
      default: 'route_code'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.route-code {
      width: 6em;
    }
  }
  .route-code .el-tag {
    width: 2.5em !important;
    text-align: center;
    color: #606266;
    background-color: #e9e7e7;
    border-color: #e9e7e7;
  }
}
</style>
